import { Outlet, useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/admin-design/_common'
import {
  LayoutDashboard,
  Users,
  Film,
  Upload,
  Factory as FactoryIcon,
  Rss,
  Activity,
  Settings,
} from 'lucide-react'
import { api } from '@/api/client'

const navItems = [
  {
    to: '/',
    label: 'Dashboard',
    end: true,
    icon: <LayoutDashboard size={14} aria-hidden="true" />,
  },
  { to: '/characters', label: 'Characters', icon: <Users size={14} aria-hidden="true" /> },
  { to: '/videos', label: 'Videos', icon: <Film size={14} aria-hidden="true" /> },
  { to: '/publish', label: 'Publish', icon: <Upload size={14} aria-hidden="true" /> },
  { to: '/factory', label: 'Factory', icon: <FactoryIcon size={14} aria-hidden="true" /> },
  { to: '/sources', label: 'Sources', icon: <Rss size={14} aria-hidden="true" /> },
  { to: '/jobs', label: 'Jobs', icon: <Activity size={14} aria-hidden="true" /> },
  { to: '/settings', label: 'Settings', icon: <Settings size={14} aria-hidden="true" /> },
]

export default function Layout() {
  const nav = useNavigate()
  const onLogout = async () => {
    try {
      await api.logout()
    } finally {
      nav('/login')
    }
  }
  return (
    <AdminLayout brand="Studio" navItems={navItems} onLogout={onLogout}>
      <Outlet />
    </AdminLayout>
  )
}
